export default __webpack_public_path__ + "static/media/screenshot1.26228c02.png";